import { useQuery } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { getAgentByUidUidV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAdvisorDetailQuery = (id?: string) =>
	useQuery({
		queryKey: AdvisorKeys.detail(id ?? ""),
		queryFn: processResponseQuery(() => getAgentByUidUidV2(id ?? ""), {
			nullOn404: true,
		}),
		enabled: Boolean(id),
	});
